import { useTabManager } from '../hooks/useTabManager';
import { ContentContainer } from './styled';
export function TabContent(props) {
    const { children, tabId, className } = props;
    const { activeTab, tabGroupId } = useTabManager();
    if (tabId !== activeTab) {
        return null;
    }
    return (<ContentContainer tabIndex={activeTab === tabId ? 0 : -1} role="tabpanel" aria-labelledby={`${tabId}-${tabGroupId}`} className={className}>
      {children}
    </ContentContainer>);
}
